module.exports = __webpack_public_path__ + "img/public.10d4ddc6.svg";